import { render, staticRenderFns } from "./CaretRight.vue?vue&type=template&id=5db4a958&"
import script from "./CaretRight.vue?vue&type=script&setup=true&lang=js&"
export * from "./CaretRight.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports